import { useEffect, useState, useCallback } from "react";

const useBreakpoint = () => {
  const getBreakpoint = useCallback((width) => {
    // same conversion as css breakpoints
    const breakpoints = {
      xldesktop: 1280,
      desktop: 1120,
      laptop: 1024,
      tablet: 800,
      phablet: 600,
      mobile: 400,
    };

    if (width >= breakpoints.xldesktop) {
      return { size: width, type: "xldesktop" };
    }
    if (width >= breakpoints.desktop) {
      return { size: width, type: "desktop" };
    }
    if (width >= breakpoints.laptop) {
      return { size: width, type: "laptop" };
    }
    if (width >= breakpoints.tablet) {
      return { size: width, type: "tablet" };
    }
    if (width >= breakpoints.phablet) {
      return { size: width, type: "phablet" };
    }
    if (width >= breakpoints.mobile) {
      return { size: width, type: "mobile" };
    }
    return { size: width, type: "xsmobile" };
  }, []);

  const [screen, setScreen] = useState(getBreakpoint(window.innerWidth));

  useEffect(() => {
    const handleResize = () => setScreen(getBreakpoint(window.innerWidth));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getBreakpoint]);

  return screen; // returns { size: number, type: string }
};

export default useBreakpoint;
